import React from 'react';
import debounce from 'debounce';
import {GridList, GridTile} from 'material-ui/GridList';
import {Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import Subheader from 'material-ui/Subheader';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SmartTable from './SmartTable/SmartTable'
import { hashHistory } from 'react-router'

import ViewListIcon from 'material-ui/svg-icons/action/view-list';
import ViewModuleIcon from 'material-ui/svg-icons/action/view-module';
import ContentAddIcon from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/image/edit';

import EntityEdit from './entityEdit';

import utils from './../misc/utils';
var config = utils.getConfig();

const Styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  gridList: {
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  gridListItem: {
  },
  gridEditColumn: {
    width: 32,
    paddingRight: 20,
    paddingLeft: 0
  },
  loadingProgress: {
    margin: 'auto'
  },
  addItemBotton: {
    margin: 0,
    top: 'auto',
    right: 50,
    bottom: 50,
    left: 'auto',
    position: 'fixed',
  },
  dialogContentStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '961px',
    maxWidth: 'none'
  },
  deleteButton: {
    color: 'red'
  }
};

class EntityList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.toggleDisplayView = this.toggleDisplayView.bind(this);
    this.loadDataFromServerImmediately = this.loadDataFromServerImmediately.bind(this);
    this.loadDataFromServer = debounce(this.loadDataFromServer.bind(this), 500);
    this.handleSearchCriteriaChange = this.handleSearchCriteriaChange.bind(this);
    this.showEdit = this.showEdit.bind(this);
    this.closeEdit = this.closeEdit.bind(this);
    this.insertEntity = this.insertEntity.bind(this);
    this.updateEntity = this.updateEntity.bind(this);
    this.deleteEntity = this.deleteEntity.bind(this);
    this.closeConfirmeDeleteDialog = this.closeConfirmeDeleteDialog.bind(this);
    this.onTableEntitySelected = this.onTableEntitySelected.bind(this);
    this.getAllowEdit = this.getAllowEdit.bind(this);
    this.getAllowAdd = this.getAllowAdd.bind(this);
    this.getAllowDelete = this.getAllowDelete.bind(this);
    this.updateInlineEntity = this.updateInlineEntity.bind(this);

    this.state = {
      data: [],
      searchCriteria: '',
      isLoading: true,
      useListView: true,
      isEditing: false,
      isConfirmDeleteDialogOpen: false,
      currentEntity: null,
      currentEntityClone: null
    };
  }

  loadDataFromServer(){
    this.loadDataFromServerImmediately();
  }

  loadDataFromServerImmediately(){
    var criteria = '';
    if(this.props.baseCriteria)
      criteria = '?' + this.props.baseCriteria;

    if(this.state.searchCriteria !== ''){
      if(criteria === '')
        criteria += '?';
      else
        criteria += '&';

      criteria += 'q=' + this.state.searchCriteria;
    }      

    this.setState({
      isLoading: true,
    });

    utils.getDataFromApi(this.props.apiRoute + criteria, (body) => {
      if(this.props.afterDataLoaded)
        this.props.afterDataLoaded(body);

      this.setState({
        data: body,
        isLoading: false
      });
    }, (status) => {
      if(status === 401)
        utils.navigateToLogin();
    });  
  }

  handleSearchCriteriaChange(e){
    this.setState({
      searchCriteria: e.target.value
    });
    this.loadDataFromServer();
  }

  toggleDisplayView(){
    this.setState({
      useListView: !this.state.useListView
    });
  }

  showEdit(entity){
    if(this.getAllowEdit()){
      this.setState({
        isEditing: true,
        currentEntity: entity,
        currentEntityClone: JSON.parse(JSON.stringify(entity))
      });
    }
  }

  closeEdit(save){
    if(save && this.getAllowEdit()){
      var callback = (responseEntity, entity) => {
        Object.keys(responseEntity).map(function(propertyName) {
          var propertyValue = responseEntity[propertyName];
          entity[propertyName] = propertyValue;
        });

        var resultData = this.state.data;      
        this.setState({
          isEditing: false,
          currentEntity: null,
          currentEntityClone: null
        });
      }

      var entity = this.state.currentEntity;
      var cloneEntity = this.state.currentEntityClone;

      if(!entity.ID || entity.ID <= 0)
        this.insertEntity(cloneEntity, entity, callback);   
      else
        this.updateEntity(cloneEntity, entity, callback);
    }
    else{
      this.setState({
        isEditing: false,
        currentEntity: null,
        currentEntityClone: null
      });
    }  
  }

  updateEntity(cloneEntity, currentEntity, callback){
    if(this.getAllowEdit()){
      utils.putDataToApi(this.props.apiRoute + '/' + currentEntity.ID, cloneEntity, (result) => {
        if(this.props.afterSave){
          this.props.afterSave(result.ID, cloneEntity, currentEntity, () => {
            callback(result, currentEntity);
          });
        }
        else{
          callback(result, currentEntity);
        }        
      }, (status) => {
        if(status === 401)
          utils.navigateToLogin();
      }); 
    }
  }

  insertEntity(cloneEntity, currentEntity, callback){
    if(this.getAllowAdd()){
      utils.postDataToApi(this.props.apiRoute, cloneEntity, (result) => {
        if(this.props.afterSave){
          this.props.afterSave(result.ID, cloneEntity, currentEntity, () => {
            this.state.data.push(currentEntity);
            callback(result, currentEntity);
          });
        }
        else{
          this.state.data.push(currentEntity);
          callback(result, currentEntity);
        }
      }, (status) => {
        if(status === 401)
          utils.navigateToLogin();
      });
    }
  }

  deleteEntity(showAlert){
    if(this.getAllowDelete()){
      if(showAlert)
        this.setState({isConfirmDeleteDialogOpen: true});
      else{
        utils.deleteFromApri(this.props.apiRoute + '/' + this.state.currentEntity.ID, (result) => {
          this.state.data.splice(this.state.data.indexOf(this.state.currentEntity), 1);
          this.closeEdit(false);
        }, (status) => {
          if(status === 401)
            utils.navigateToLogin();
        });

        this.closeConfirmeDeleteDialog();
      }       
    }     
  }

  updateInlineEntity(entity){
    utils.putDataToApi(this.props.apiRoute + '/' + entity.ID, entity, (result) => {
      if(this.props.afterSave)
        this.props.afterSave(result.ID, cloneEntity, currentEntity, null);
   
      this.forceUpdate();
    }, (status) => {
      if(status === 401)
        utils.navigateToLogin();
    });
  }

  closeConfirmeDeleteDialog(){
    this.setState({isConfirmDeleteDialogOpen: false});
  }

  getAllowEdit(){
    return (!this.props.hasOwnProperty('allowEdit') || this.props.allowEdit);
  }

  getAllowAdd(){
    if(this.getAllowEdit()){
      return (!this.props.hasOwnProperty('allowAdd') || this.props.allowAdd);
    }
    else{
      return false;
    }
  }

  getAllowDelete(){
    if(this.getAllowEdit()){
      return (!this.props.hasOwnProperty('allowDelete') || this.props.allowDelete);
    }
    else{
      return false;
    }
  }    

  onTableEntitySelected(entity){
    if(this.props.allowSelection && this.props.onEntitySelection)
      this.props.onEntitySelection(entity);
  }  

  componentDidMount(){
    utils.getAuthenticationHeader();
    this.loadDataFromServerImmediately();

    if(hashHistory){
      var location = hashHistory.getCurrentLocation();
      if(location.query){
        Object.keys(location.query).map((parameter) => {
          switch(parameter){
            case 'isNew':
              if(location.query.isNew === 'true')
                this.showEdit({});
            break;
          }
        });
      }
    }
  }

  render() {
    var allowEdit = this.getAllowEdit();
    var allowAdd = this.getAllowAdd();
    var allowDelete = this.getAllowDelete();

    var editActions = [];
    if(allowDelete){
      editActions.push(      
        <FlatButton
          label="Supprimer"
          style={Styles.deleteButton}
          primary={false}
          onTouchTap={() => this.deleteEntity(true)}
        />
      );
    }
    editActions.push(
      <FlatButton
        label="Annuler"
        primary={true}
        onTouchTap={() => this.closeEdit(false)}
      />,
      <FlatButton
        label="Sauvegarder"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => this.closeEdit(true)}
      />
    );

    var deleteConfirmActions = [
      <FlatButton
        label="Non"
        primary={true}
        onTouchTap={() => this.closeConfirmeDeleteDialog()}
      />,
      <FlatButton
        label="Oui"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => this.deleteEntity(false)}
      />,
    ];
    
    var tableHeaders = [];
    this.props.displayColumns.map((displayColumn) => (
      tableHeaders.push({
        alias: displayColumn.Description, 
        sortable: (displayColumn.sortable === undefined || displayColumn.sortable), 
        dataAlias: displayColumn.Column,
        style: displayColumn.style,
        format: (displayColumn.format ? displayColumn.format : {type: 'text'})        
      })
    ));    
    if(allowEdit)
      tableHeaders.push({alias:'', sortable: false, dataAlias: '', style: Styles.gridEditColumn, format: { type: 'button', action: this.showEdit, content: <EditIcon/> }});

    return (
      <div>
        <style>
          {`
            td{
              vertical-align: middle;
            }
          `}
        </style> 

        <div style={Styles.root}>
          <h1 className='markdown-body'>{this.props.title}</h1>        
          {!this.props.disableSearch &&
            <TextField fullWidth={true} hintText='Rechercher...' value={this.state.searchCriteria} onChange={this.handleSearchCriteriaChange} />
          }
          {this.state.isLoading && 
            <div style={Styles.loadingProgress}>
              <CircularProgress />
            </div>
          }
          <SmartTable onEntitySelection={this.onTableEntitySelected} allowSelection={this.props.allowSelection} updateEntityCallBack={this.updateInlineEntity} tableHeaders={tableHeaders} data={this.state.data} limit={50} total={this.state.data.length} defaultOrderBy={this.props.defaultOrderBy} />
          {
            allowAdd &&
            <FloatingActionButton onClick={() => this.showEdit({})} style={Styles.addItemBotton}>
              <ContentAddIcon />
            </FloatingActionButton>        
          }            
        </div>
        <Dialog 
          title={this.props.editTitle} 
          actions={editActions} 
          modal={true}
          contentStyle={Styles.dialogContentStyle}
          open={this.state.isEditing} 
          onRequestClose={this.closeEdit} 
          autoScrollBodyContent={true}>
          {this.props.editComponent ?
            <this.props.editComponent apiRoute={this.props.apiRoute} entity={this.state.currentEntityClone} />:
            <EntityEdit apiRoute={this.props.apiRoute} entity={this.state.currentEntityClone}/>
          }          
        </Dialog>
        <Dialog
          actions={deleteConfirmActions}
          modal={false}
          open={this.state.isConfirmDeleteDialogOpen}
          onRequestClose={this.closeConfirmeDeleteDialog}>
          Voulez-vous vraiment supprimer cet enregistrement?
        </Dialog>   
      </div>
    );
  }
}

export default EntityList;



/** WEBPACK FOOTER **
 ** ./src/app/components/entityList.js
 **/